import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
//@ts-nocheck
import React, { useEffect, useState } from 'react';
import { Button as AntdButton, Flex, Form, InputNumber, message, Input, Select, Button, Space } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { convertToBase64 } from '../../../shared/utils';
import Icon from '../../../components/common/Icon';
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { createEventAction, deleteEvent, updateEventAction, } from '../../../store/EditoreSlice';
import { LeftPanel, LeftPanelCard, LeftPanelCardBody, LeftPanelCardFooter, LeftPanelCardHead, LeftPanelContainer, } from '../editor.style';
import CustomDatePicker from '../components/DatePicker';
import ImageUploadList from '../components/imageUploadList';
import { eventTypes } from '../../../shared/utils/constants';
import dayjs from 'dayjs';
const initialValues = {
    name: '',
    description: '',
    startDate: undefined,
    endDate: undefined,
    showDate: undefined,
    externalId: '',
    locationId: '',
    images: [],
    imagesToDelete: [],
    priority: 0
    // name: 'Testing',
    // description: 'Desc',
    // startDate: '2025-01-07T18:30:00.000Z',
    // endDate: '2025-01-22T18:30:00.000Z',
    // showDate: '2025-01-14T18:30:00.000Z',
    // externalId: '123',
    // locationId: '6763c6a88489ac3bc917611c',
    // images: [],
    // imagesToDelete: [],
};
const EventPanel = ({ eventData, siteId, isOpen, onBack }) => {
    const dispatch = useDispatch();
    const locationSiblings = useSelector((state) => state?.editor?.locationSiblings.response);
    const [form] = Form.useForm();
    const [container, setContainer] = useState(null);
    const [editEvent, setEditEvent] = useState(false);
    useEffect(() => {
        if (eventData) {
            const data = Object.entries(eventData?.customFields || {})?.map(([key, item]) => ({
                name: key,
                value: item.data,
                order: item.order
            }));
            const sortedData = data.sort((a, b) => a.order - b.order);
            eventData.customFields = sortedData;
            form.setFieldsValue(eventData);
            setEditEvent(eventData);
        }
        else {
            form.setFieldsValue(initialValues);
            setEditEvent(false);
        }
        form.setFieldValue('imagesToDelete', []);
    }, [eventData]);
    const { createEvent: { loading: creatingEvent }, updateEvent: { loading: updatingEvent }, deleteEvent: { loading: deletingEvent }, } = useSelector((state) => state?.editor);
    const categoryIcons = useSelector((state) => state?.editor?.categoryIcons?.response);
    const validateStartDate = (_, startDate) => {
        const endDate = form.getFieldValue('endDate');
        // Convert to moment for comparison
        const startMoment = startDate ? dayjs(startDate) : null;
        const endMoment = endDate ? dayjs(endDate) : null;
        if (endMoment && startMoment && startMoment.isAfter(endMoment)) {
            return Promise.reject(new Error('Start date cannot be after the end date.'));
        }
        if (!startDate) {
            return Promise.reject(new Error('Start date is required.'));
        }
        return Promise.resolve();
    };
    const validateEndDate = (_, endDate) => {
        const startDate = form.getFieldValue('startDate');
        // Convert to moment for comparison
        const endMoment = endDate ? dayjs(endDate) : null;
        const startMoment = startDate ? dayjs(startDate) : null;
        if (startMoment && endMoment && endMoment.isBefore(startMoment)) {
            return Promise.reject(new Error('End date cannot be before the start date.'));
        }
        if (!endDate) {
            return Promise.reject(new Error('End date is required.'));
        }
        return Promise.resolve();
    };
    return (_jsx(_Fragment, { children: _jsx(LeftPanel, { isOpen: isOpen, style: {
                width: '340px',
            }, children: _jsx(LeftPanelContainer, { children: _jsxs(LeftPanelCard, { children: [_jsx(LeftPanelCardHead, { children: _jsxs(Flex, { align: "center", children: [_jsx(AntdButton, { style: { marginLeft: '-8px' }, color: "default", variant: "text", icon: _jsx(Icon, { icon: "arrow-left", size: 18 }), onClick: () => {
                                            onBack();
                                        } }), _jsx("h3", { children: !!editEvent ? 'Edit Event' : 'Create New Event' })] }) }), _jsx(LeftPanelCardBody, { style: { padding: '0 16px 16px' }, ref: setContainer, children: _jsxs(Form, { initialValues: editEvent || initialValues, form: form, layout: "vertical", onFinish: async (values) => {
                                    try {
                                        // return;
                                        if (!siteId)
                                            return;
                                        let payload = { ...values };
                                        payload.customFields = payload?.customFields?.reduce((acc, item, index) => {
                                            acc[item.name] = { data: item.value, order: index };
                                            return acc;
                                        }, {});
                                        let fileUpload = [];
                                        let fileDelete = [];
                                        // Handle image file conversion to base64 if images is present
                                        if (payload.images?.length > 0) {
                                            payload.images.forEach(async (item, index) => {
                                                if (!item.originFileObj)
                                                    return;
                                                const base64 = (await convertToBase64(item.originFileObj)).split(',')[1];
                                                fileUpload.push({
                                                    fileName: Date.now().toString() + `${index}`,
                                                    image: base64,
                                                });
                                            });
                                        }
                                        if (payload?.imagesToDelete?.length > 0) {
                                            fileDelete = payload?.imagesToDelete;
                                        }
                                        delete payload.images;
                                        delete payload.imagesToDelete;
                                        const actionPayload = {
                                            data: {
                                                ...payload,
                                                siteId: siteId ?? payload.siteId,
                                            },
                                            fileUpload,
                                            fileDelete,
                                        };
                                        console.log({ actionPayload });
                                        // return;
                                        // Choose action based on whether editEvent is set
                                        const action = editEvent
                                            ? updateEventAction({
                                                siteId,
                                                eventId: editEvent.eventId,
                                                ...actionPayload,
                                            })
                                            : createEventAction(actionPayload);
                                        // Dispatch the action and handle response
                                        dispatch(action).then((res) => {
                                            if (!res.error) {
                                                message.success(editEvent ? 'Event updated successfully' : 'Event created successfully');
                                                form.resetFields();
                                                onBack();
                                            }
                                            else {
                                                message.error(res?.payload?.message || 'Something went wrong');
                                            }
                                        });
                                    }
                                    catch (error) {
                                        console.log({ error });
                                        message.error('Something went wrong');
                                    }
                                }, children: [_jsx(Form.Item, { name: "name", label: "Name", required: true, tooltip: "This is a required field", rules: [{ required: true, message: 'Name is required' }], children: _jsx(Input, { placeholder: "Event Name", variant: "filled" }) }), _jsx(Form.Item, { name: "type", label: "Type", rules: [{ required: true }], children: _jsx(Select, { variant: "filled", allowClear: true, placeholder: "Select Type", options: (eventTypes || [])?.map((it) => ({
                                                label: it,
                                                value: it,
                                            })) }) }), _jsx(Form.Item, { name: "description", label: "Description", required: true, tooltip: "This is a required field", rules: [{ required: true, message: 'Description is required' }], children: _jsx(Input.TextArea, { placeholder: "Description", variant: "filled" }) }), _jsx(Form.Item, { required: true, label: "Start Date and Time", name: "startDate", rules: [{ validator: validateStartDate }], children: _jsx(CustomDatePicker, { showTime: { format: "HH:mm" } }) }), _jsx(Form.Item, { required: true, label: "End Date and Time", name: "endDate", rules: [{ validator: validateEndDate }], children: _jsx(CustomDatePicker, { showTime: { format: "HH:mm" } }) }), _jsx(Form.Item, { label: "Show Date", name: "showDate", rules: [{ required: true }], children: _jsx(CustomDatePicker, {}) }), _jsx(Form.Item, { label: "External Id", name: "externalId", rules: [{ required: true }], children: _jsx(Input, {}) }), _jsx("div", { children: "Custom Attributes" }), _jsx(Form.List, { name: "customFields", label: "Custom Attributes", children: (customFields, { add, remove }) => {
                                            const validateUniqueName = (rule, value, callback) => {
                                                const names = customFields.map(field => form.getFieldValue(['customFields', field.name, 'name']));
                                                if (value && names.filter(name => name === value).length > 1) {
                                                    callback('Name must be unique');
                                                }
                                                else {
                                                    callback();
                                                }
                                            };
                                            return (_jsxs(_Fragment, { children: [customFields.map(({ key, name, ...restField }) => (_jsxs(Space, { style: { display: "flex", marginBottom: 8 }, align: "baseline", children: [_jsx(Form.Item, { ...restField, name: [name, "name"], rules: [{ required: true, message: "Missing name" }, { validator: (rule, value, callback) => validateUniqueName(rule, value, callback, customFields) }], children: _jsx(Input, { placeholder: "Name" }) }), _jsx(Form.Item, { ...restField, name: [name, "value"], rules: [{ required: true, message: "Missing value" }], children: _jsx(Input, { placeholder: "Value" }) }), _jsx(MinusCircleOutlined, { onClick: () => remove(name), style: { color: "red" } })] }, key))), _jsx(Button, { type: "dashed", onClick: () => add(), icon: _jsx(PlusOutlined, {}), children: "Add Field" })] }));
                                        } }), _jsx(Form.Item, { name: "locationId", label: "Location", rules: [{ required: true }], children: _jsx(Select, { variant: "filled", allowClear: true, placeholder: "Select Location", options: (locationSiblings || [])?.map((it) => ({
                                                label: it.name,
                                                value: it.locationId,
                                            })), optionFilterProp: "label", filterSort: (optionA, optionB) => (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase()), showSearch: true }) }), _jsx(Form.Item, { label: "Priority", name: "priority", rules: [{ required: true }], children: _jsx(InputNumber, { min: 0, step: 1, variant: "filled", style: { width: '100%' } }) }), _jsx(Form.Item, { hidden: true, name: "imagesToDelete" }), _jsx(Form.Item, { label: "Images", name: "images", tooltip: "You can upload multiple images", children: _jsx(ImageUploadList, { onRemove: (file) => {
                                                if (!file?.originFileObj) {
                                                    let imagesToDelete = form.getFieldValue('imagesToDelete');
                                                    if (imagesToDelete) {
                                                        imagesToDelete.push(file.url);
                                                    }
                                                    else {
                                                        imagesToDelete = [file.url];
                                                    }
                                                    form.setFieldValue('imagesToDelete', imagesToDelete);
                                                }
                                            } }) })] }) }), _jsxs(LeftPanelCardFooter, { children: [_jsx(Button, { loading: deletingEvent, onClick: () => {
                                        if (!!editEvent) {
                                            if (siteId) {
                                                dispatch(deleteEvent({
                                                    siteId,
                                                    eventId: editEvent.eventId,
                                                }))
                                                    .then((res) => {
                                                    //@ts-ignore
                                                    if (!res.error) {
                                                        message.success('Event deleted successfully');
                                                        onBack();
                                                    }
                                                    else {
                                                        message.error('Something went wrong');
                                                    }
                                                })
                                                    .catch((error) => {
                                                    console.error(error);
                                                    message.error('Something went wrong');
                                                });
                                            }
                                        }
                                        else {
                                            onBack();
                                        }
                                    }, color: "danger", variant: "filled", children: !!editEvent ? 'Delete' : 'Cancel' }), _jsx(Button, { disabled: deletingEvent, loading: creatingEvent || updatingEvent, onClick: () => {
                                        form.submit();
                                    }, color: "primary", variant: "solid", children: "Save" })] })] }) }) }) }));
};
export default React.memo(EventPanel);
